// @core/api/endpoints/tenant/get_tenant_data_export.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  TenantDataExportResponse,
} from '../../../types/tenant';

const BASE_PATH = '/tenant';

/**
 * Get data export status
 * Returns the current status of a tenant data export request, including progress and download link if completed.
 */
export async function GetTenantDataExport(
  tenant_id: string,
  export_id: string,
  options?: RequestOptions
): Promise<TenantDataExportResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:tenant_id/data-export/:export_id`;
  requestPath = requestPath.replace(':tenant_id', encodeURIComponent(tenant_id));
  requestPath = requestPath.replace(':export_id', encodeURIComponent(export_id));
  const requestOptions = options;
  return client.get<TenantDataExportResponse>(requestPath, { ...requestOptions });
}
